import { Button, useRefresh, useNotify, useRecordContext, useStore, SelectInput, TextInput, required } from "react-admin";
import { Typography } from "@mui/material";

import { StaffRequestActionSubjects, StaffRequestTypes } from "utils/constants";
import { useNavigate } from "react-router";
import { useState } from "react";
import FormModal from "server/components/Modals/FormModal";
import { employeeRequests } from "api/employeeApi";
import dataProvider from "server/dataProvider";
import { PENDING_COUNT_VERSION_KEY } from "../components/PendingRequestsTitle";

const RequestActionButton = ({ action, label, icon, color, requestId, type, requestAction, status, redirectBack = true, reasonOptionVisible }) => {
  const record = useRecordContext();
  const staffRequestId = requestId ?? record?.staffRequestId ?? record?.id;
  const refresh = useRefresh();
  const notify = useNotify();
  const navigate = useNavigate();
  const [, setPendingCountVersion] = useStore(PENDING_COUNT_VERSION_KEY, 0);
  const [statusReason, setStatusReason] = useState([]);
  const hasChoices = statusReason && statusReason?.length > 0;
  if (reasonOptionVisible === undefined) {
    reasonOptionVisible = type === StaffRequestTypes.AnnualLeave
      || type === StaffRequestTypes.SickLeave
      || type === StaffRequestTypes.BusinessTrip;
  }

  const title = `Сигурни ли сте, че искате да ${action} ${StaffRequestActionSubjects[type] ?? "заявката"}?`;

  const handleGetStatusReason = async () => {
    try {
      const { data } = await dataProvider.customRequest(
        employeeRequests.getStaffRequestStatusReasons({ type, status }),
        null,
        "GET",
      );
      setStatusReason(data || []);
    } catch (err) {
      console.error(err);
    }
  };

  const handleSend = async data => {
    const payload = {
      ...(data?.statusReasonId && { statusReasonId: data.statusReasonId }),
      ...(data?.comment && { comment: data.comment }),
    };
    await dataProvider.customRequest(
      requestAction === "confirm"
        ? employeeRequests.approveStaffRequest(staffRequestId)
        : employeeRequests.rejectStaffRequest(staffRequestId),
      payload,
      "PUT",
    );
    refresh();
    setPendingCountVersion(v => v + 1);
    notify("Успешно финализирана заявка", { type: "success" });
    if (redirectBack) navigate(-1);
  };

  return (
    <FormModal
      onConfirm={handleSend}
      onOpen={handleGetStatusReason}
      titleContent={"Финализирай заявка"}
      triggerButton={
        <Button
          size="medium"
          variant="outlined"
          color={color}
          label={label}
        >
          {icon}
        </Button>
      }
    >
      <Typography sx={{ my: 2 }}>{title}</Typography>

      {reasonOptionVisible && (
        <>
          <Typography>
            Коментар (незадължително)
          </Typography>
          <TextInput
            source="comment"
            label=""
            fullWidth
            multiline
            minRows={2}
          />
        </>
      )}

      {hasChoices && (
        <SelectInput
          source="statusReasonId"
          label="Причина"
          choices={statusReason}
          optionText="name"
          emptyText={false}
          fullWidth
          validate={required()}
        />
      )}
    </FormModal>
  );
};

export default RequestActionButton;
